module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_footer_sola-0e7986fb76ce18cdefcea7af554f1f0a.svg";